import axios from 'axios';
import showErrorView from '@/utils/showErrorView';

export const Api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

Api.interceptors.response.use(
  (response) => response,
  async (error) => {
    await showErrorView(error.response.data.message, '');
    return Promise.reject(error);
  },
);
